
import React from "react";
import { Button } from "@/components/ui/button";
import { LoadingButton } from "@/components/ui/loading-button";

interface NumberOption {
  number_id: string;
  e164: string;
  area_code: string | null;
  status: string;
  country: string;
}

type Props = {
  existingNumbers: NumberOption[];
  selectedNumberId: string | null;
  setSelectedNumberId: (id: string) => void;
  error: string | null;
  onPrev: () => void;
  onNext: () => void;
  loading: boolean;
  setShowBuyNew: (v: boolean) => void;
  setError: (e: string | null) => void;
};

const Step2NumberSelectExisting: React.FC<Props> = ({
  existingNumbers,
  selectedNumberId,
  setSelectedNumberId,
  error,
  onPrev,
  onNext,
  loading,
  setShowBuyNew,
  setError,
}) => {
  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    if (!selectedNumberId) {
      setError("Please select a number or choose to buy a new one.");
      return;
    }
    onNext();
  };
  return (
    <form className="space-y-4" onSubmit={handleSubmit}>
      <div>
        <h3 className="text-lg font-medium mb-2">
          Use an existing number in your account
        </h3>
        <p className="text-muted-foreground mb-4">
          Select one of your existing numbers or buy a new one.
        </p>
        <select
          value={selectedNumberId || ""}
          onChange={(e) => setSelectedNumberId(e.target.value)}
          className="block w-full border border-gray-300 rounded px-4 py-2"
        >
          <option value="">Select a number...</option>
          {existingNumbers.map((num) => (
            <option key={num.number_id} value={num.number_id}>
              {num.e164} {num.status !== "active" ? `(${num.status})` : ""}
            </option>
          ))}
        </select>
      </div>
      {error && <div className="text-red-500 text-sm">{error}</div>}
      <div className="flex space-x-2 mt-2">
        <Button type="button" variant="secondary" onClick={onPrev}>
          Back
        </Button>
        <LoadingButton type="submit" loading={loading || false}>
          Continue
        </LoadingButton>
        <Button
          type="button"
          variant="ghost"
          onClick={() => {
            setShowBuyNew(true);
            setError(null);
          }}
        >
          Or, buy a new number
        </Button>
      </div>
    </form>
  );
};

export default Step2NumberSelectExisting;
